<div
  class="number-badge"
  [class.number-badge--clickable]="this.clickable"
>
  {{ value }}
</div>
